import {
  _delete,
  _get,
  _patch,
  _post,
  getUrlQueryParameterFromObject,
} from './apiClient'


export const URL_BASE_ACTIONS = 'actions'
export const URL_BASE_ACTIONS_SOURCES = 'actions_sources'
export const URL_BASE_APPS_AND_ACTIONS_SOURCES = 'sources'
export const URL_BASE_ACTIONS_PRODUCTS = 'products'
export const URL_BASE_PMM_ACTIONS_EQUIPMENTS = 'integrations/pmm/equipments'

export function createAction (data) {
  const url = `${URL_BASE_ACTIONS}/?format=expanded`
  return _post(url, data)
}

export function patchAction (actionId, data) {
  const url = `${URL_BASE_ACTIONS}/${actionId}/?format=expanded`
  return _patch(url, data)
}

export function fetchAction (actionId, queryParams = { format: 'expanded' }) {
  const queryParamsString = getUrlQueryParameterFromObject(queryParams, false)
  let url = `${URL_BASE_ACTIONS}/${actionId}/`
  url = queryParamsString !== '' ? `${url}?${queryParamsString}` : url
  return _get(url)
}

export function deleteAction (actionId) {
  const url = `${URL_BASE_ACTIONS}/${actionId}/`
  return _delete(url)
}

export function fetchActionSources (active = true) {
  const url = active ? `${URL_BASE_ACTIONS_SOURCES}/?active=True` : `${URL_BASE_ACTIONS_SOURCES}/`
  return _get(url)
}

let allSourcesPromise = null
export function fetchAllActionSources () {
  if (allSourcesPromise) {
    return allSourcesPromise
  }
  const url = `${URL_BASE_ACTIONS_SOURCES}/`
  allSourcesPromise = _get(url).catch(e => {
    allSourcesPromise = null
    throw e
  })
  return allSourcesPromise
}

export function fetchActionAndAppsSources () {
  const url = `${URL_BASE_ACTIONS}/${URL_BASE_APPS_AND_ACTIONS_SOURCES}/?active=True`
  return _get(url)
}

let allActionsAndAppsSourcesPromise = null
export function fetchAllActionAndAppsSources () {
  if (allActionsAndAppsSourcesPromise) {
    return allActionsAndAppsSourcesPromise
  }
  const url = `${URL_BASE_ACTIONS}/${URL_BASE_APPS_AND_ACTIONS_SOURCES}/`
  allActionsAndAppsSourcesPromise = _get(url).catch(e => {
    allActionsAndAppsSourcesPromise = null
    throw e
  })
  return allActionsAndAppsSourcesPromise
}

export function fetchActionProducts (active = true) {
  const url = active ? `${URL_BASE_ACTIONS}/${URL_BASE_ACTIONS_PRODUCTS}/?active=True` : `${URL_BASE_ACTIONS}/${URL_BASE_ACTIONS_PRODUCTS}/`
  return _get(url)
}

let allProductsPromise = null
export function fetchAllActionProducts () {
  if (allProductsPromise) {
    return allProductsPromise
  }
  const url = `${URL_BASE_ACTIONS}/${URL_BASE_ACTIONS_PRODUCTS}/`
  allProductsPromise = _get(url).catch(e => {
    allProductsPromise = null
    throw e
  })
  return allProductsPromise
}

export function getActionsByCriterion (criterionId) {
  const url = `${URL_BASE_ACTIONS}/?audit_criteria=${criterionId}&format=expanded`
  return _get(url)
}

export function fetchActionsHistoryCountByTemplate (excludeCriterionId, templateCriterionId, perimeterId, optionalStatuses = null) {
  const parameters = {
    perimeters_exact: perimeterId,
    audit_template_criteria: templateCriterionId,
    audit_criteria_excluded: excludeCriterionId,
    offset: 0,
    limit: 1,
    status_values: optionalStatuses ? optionalStatuses.join(',') : undefined,
    format: 'info',
  }
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_ACTIONS}/${queryParams}`
  return _get(url)
}
export function fetchPMMActionEquipments () {
  const url = `${URL_BASE_PMM_ACTIONS_EQUIPMENTS}/`
  return _get(url)
}
